import type { ProductView } from '@medistock/contracts';

/** Product tiles with the open lot and the expected balance (spec §6). */
export function StaffHome({
  products,
  onPick,
}: {
  products: ProductView[];
  onPick: (product: ProductView) => void;
}) {
  return (
    <div className="tiles" data-testid="product-tiles">
      {products.map((p) => {
        const state = !p.activeVial ? 'none' : p.lowStock ? 'low' : 'ok';
        return (
          <button
            key={p.id}
            className="tile"
            data-testid={`product-${p.id}`}
            onClick={() => onPick(p)}
            disabled={!p.activeVial}
          >
            <span className="name">{p.name}</span>
            <span className="meta">
              {p.brand} · {p.unit}
            </span>
            <span className="remain">
              <span className={`dot ${state}`} />
              {p.activeVial
                ? `${p.activeVial.remaining} ${p.unit} left · lot ${p.activeVial.lot}`
                : 'No open vial — ask a manager'}
            </span>
          </button>
        );
      })}
      {products.length === 0 ? <p className="notice info">No products configured yet.</p> : null}
    </div>
  );
}
